/* Collection page — infinite scroll via paginate.next URL.
   Fetches the next page server-rendered, extracts the .product-card nodes,
   appends them to the grid, then advances the page counter. */
(() => {
  const section = document.querySelector('[data-section="collection"]');
  if (!section) return;

  const grid = section.querySelector('[data-grid]');
  const sentinel = section.querySelector('[data-sentinel]');
  const endEl = section.querySelector('[data-end]');
  const handle = section.dataset.collectionHandle;
  let page = Number(section.dataset.currentPage) || 1;
  const total = Number(section.dataset.totalPages) || 1;
  let loading = false;

  if (!grid || !sentinel || page >= total) {
    if (sentinel) sentinel.hidden = true;
    if (endEl) endEl.hidden = false;
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const sort = params.get('sort_by') || '';

  async function loadMore() {
    if (loading || page >= total) return;
    loading = true;
    page += 1;
    const url = new URL(`/collections/${handle}`, window.location.origin);
    url.searchParams.set('page', page);
    if (sort) url.searchParams.set('sort_by', sort);
    try {
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = doc.querySelectorAll('[data-section="collection"] [data-grid] .product-card');
      cards.forEach((c) => grid.appendChild(c));
    } catch (err) {
      console.error('Infinite scroll fetch failed:', err);
      page -= 1;
    } finally {
      loading = false;
      if (page >= total) {
        sentinel.hidden = true;
        if (endEl) endEl.hidden = false;
        observer.disconnect();
      }
    }
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) loadMore(); });
  }, { rootMargin: '600px 0px' });
  observer.observe(sentinel);
})();
